import { render, staticRenderFns } from "./SidebarMenuItem.vue?vue&type=template&id=d151ad6e"
import script from "./SidebarMenuItem.vue?vue&type=script&lang=js"
export * from "./SidebarMenuItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports